<template>
  <div>
    <h3>Add Site</h3>
    <b-card no-body>
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <tab-item icon="users" heading="Step 1" subheading="Details"></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Details</strong>
                <p class="muted">Enter the general details of this site here.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">

                  <b-form-group label="Site Name"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.name.$error }">
                    <b-form-input v-model="form.name" type="text" :class="{ 'is-invalid': $v.form.name.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.name.$error">You must enter a name.</span>
                  </b-form-group>

                  <b-form-group label="Description"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.description.$error }">
                    <vue-editor id="descriptionEditor" v-model="form.description"></vue-editor>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.description.$error">You must enter a description.</span>
                  </b-form-group>

                  <b-form-group label="Contract Required"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.contractRequirementTypeId.$error }">
                    <b-form-select v-model="form.contractRequirementTypeId"
                                  :options="contractRequirementTypes"
                                  value-field="contractRequirementTypeId"
                                  text-field="name"
                                  :class="{ 'is-invalid': $v.form.contractRequirementTypeId.$error }"></b-form-select>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.contractRequirementTypeId.$error">You must select a contract requirement.</span>
                  </b-form-group>

                  <b-form-group label="Street Address"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.streetAddress.$error }">
                    <b-form-input v-model="form.streetAddress" type="text" :class="{ 'is-invalid': $v.form.streetAddress.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.streetAddress.$error">You must enter a street address.</span>
                  </b-form-group>

                  <b-form-group label="City"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.city.$error }">
                    <b-form-input v-model="form.city" type="text" :class="{ 'is-invalid': $v.form.city.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.city.$error">You must enter a city.</span>
                  </b-form-group>

                  <b-form-group label="State"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.state.$error }">
                    <b-form-input v-model="form.state" type="text" :class="{ 'is-invalid': $v.form.state.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.state.$error">You must enter a state.</span>
                  </b-form-group>

                  <b-form-group label="Zip"
                                label-class="control-label site-form-label"
                                :class="{ 'invalid-group': $v.form.zip.$error }">
                    <b-form-input v-model="form.zip" type="text" :class="{ 'is-invalid': $v.form.zip.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.zip.$error">You must enter a zip.</span>
                  </b-form-group>

                  <b-form-group label="Website" label-class="control-label site-form-label">
                    <b-form-input v-model="form.website" type="text"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Phone" label-class="control-label site-form-label">
                    <b-form-input v-model="form.phone" type="text"></b-form-input>
                  </b-form-group>

                  <!-- <b-form-group label="Fax" label-class="control-label site-form-label">
                    <b-form-input v-model="form.fax" type="text"></b-form-input>
                  </b-form-group> -->

                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>

      </b-tabs>
    </b-card>
    <b-button class="btn-primary pull-right save-site-button" @click="saveSite()">Save</b-button>
  </div>
</template>

<script>
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import TabItem from "../menu/tab-item";
import { VueEditor } from "vue2-editor";
import { required } from "vuelidate/lib/validators";
import sitesApi from "../../api/sites";
import formApply from "../../components/opportunities/form/form-apply";

var htmlEncode = require("js-htmlencode").htmlEncode;

export default {
  data() {
    return {
      form: {
        name: null,
        description: null,
        contractRequirementTypeId: null,
        streetAddress: null,
        city: null,
        state: null,
        zip: null,
        website: null,
        phone: null,
        fax: null
      }
    };
  },

  props: {
    contractRequirementTypes: {
      type: Array,
      required: true
    },

    site: {
      type: Object
    },
    applicationTypes: {
      type: Array,
      required: true
    }
  },

  validations: function() {
    var validate = {
      form: {
        name: {
          required
        },
        description: {
          required
        },
        contractRequirementTypeId: {
          required
        },
        streetAddress: {
          required
        },
        city: {
          required
        },
        state: {
          required
        },
        zip: {
          required
        }
      }
    };
    return validate;
  },

  watch: {
    site: function() {
      this.form = this.site;
    }
  },

  components: {
    "tab-item": TabItem,
    "form-apply": formApply,
    VueEditor
  },

  methods: {
    saveSite: function() {
      this.$v.$touch();

      // only submit if the form is valid
      if (!this.$v.$error) {
        // encode html
        this.form.description = htmlEncode(this.form.description);

        if (this.site) {
          // if site prop has been used, call edit function
          this.submitEditedSite();
        } else {
          // otherwise, add it as a new site
          this.submitNewSite();
        }
      }
    },

    submitNewSite: function() {
      var that = this;
      sitesApi
        .postSite(this.form)
        .then(function(response) {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The site has been saved.", "Success");

          // redirect
          that.$router.push({
            name: "site",
            params: { siteId: response.data }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    submitEditedSite: function() {
      var that = this;
      sitesApi
        .postEditSite(this.form)
        .then(function(response) {
          toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-top-right",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "0",
            timeOut: "5000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
          };

          // Toastr Message
          toastr.success("The site has been edited.", "Success");

          // redirect
          that.$router.push({
            name: "site",
            params: { siteId: response.data }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.form-panel {
  font-size: 13px;
}

.form-panel .site-form-label {
  margin-bottom: 0;
  padding-bottom: 0;
}

.card {
  margin-bottom: 10px;
}

.invalid-group > .control-label {
  color: #dc3545;
}

.span-feedback.invalid-feedback {
  display: block;
}
</style>
